export default {"src":"/_next/static/media/paardensport.4b50450a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};